<era-master-detail flexGrowLeft="2"
                   flexGrowRight="1"
                   [isH2]="false">
  <era-master>
    <era-panel>
      <div class="px-3">
        <era-devices-unassigned></era-devices-unassigned>
      </div>
    </era-panel>
  </era-master>
</era-master-detail>